import { render, staticRenderFns } from "./footPressure.vue?vue&type=template&id=214c257e&scoped=true&"
import script from "./footPressure.vue?vue&type=script&lang=js&"
export * from "./footPressure.vue?vue&type=script&lang=js&"
import style0 from "./footPressure.vue?vue&type=style&index=0&id=214c257e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c257e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('214c257e')) {
      api.createRecord('214c257e', component.options)
    } else {
      api.reload('214c257e', component.options)
    }
    module.hot.accept("./footPressure.vue?vue&type=template&id=214c257e&scoped=true&", function () {
      api.rerender('214c257e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/footPressure.vue"
export default component.exports